<script>
export const group = 'Full'
</script>

<script setup>
import Image from '../default/Image.vue'
import InformationSurface from './shared/InformationSurface.vue'
import Reveal from './shared/Reveal.vue'

defineProps({
  item: Object,
})

const revealComponent = ref(null)
const onImageLoaded = () => {
  revealComponent.value.start()
}
</script>

<template>
  <Reveal ref="revealComponent" manualStart>
    <InformationSurface>
      <template #full>
        <Image :item="item" class="!bg-transparent" @load="onImageLoaded" />
      </template>
    </InformationSurface>
  </Reveal>
</template>
